import React, { Component } from 'react';
import PropTypes from 'prop-types';

class DynamicCard extends Component {
    constructor(props){
        super(props)
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(key, value){
        if(value === "SiL/MiL Testing"){
            value = "Stage 1 Simulation"
        }
        const keyValue = key.toLowerCase().split(" ").join("_")
        this.props.property.history.push(`/view_scenario_catalogue/{"${keyValue}":"${this.props.type}_${value}"}`)
    }

    render() {
        return (
            <div data-test = 'scenarioCatalogueDynamicCardComponent'>
                {Object.keys(this.props.value).map( ( element, index ) => {
                    return (
                        <div className="card" key={index}>
                            <div className="card-header"
                                style={ this.props.type === "passenger" ?
                                { backgroundColor: "#757AF7", color: "white", fontSize: "21px"}
                                : {backgroundColor: "#8FD800", color: "#622AD8",  fontSize: "21px" }}
                            >
                                <div className="row">
                                    {this.props.icon}
                                     {element}
                                </div>
                            </div>
                            <div className="card-body">
                                {Object.keys(this.props.value[element]).map( (subElement, subIndex) => {
                                    return (
                                        <div style={{ color: "#464646" }} key={subIndex} onClick={ () => { this.handleClick(element, subElement) } }>
                                            <div className="scenario-value" id={`${element}-${subElement}`} style={{ paddingTop: "2%", paddingBottom: "2%" }}>
                                                <button style={{ paddingLeft: "4%" }} id={`${element}-${subElement}`} className="text-left">{subElement}</button>
                                                <span style={{ paddingRight: "4%" }} className="float-right">{this.props.value[element][subElement]}</span>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }
}
DynamicCard.propTypes={
property:PropTypes.string,
type:PropTypes.string,
value:PropTypes.string,
icon:PropTypes.string,
}
DynamicCard.defaultProps= {
property:[],
type:[],
value:[],
icon:[],
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

export default DynamicCard;
